import Typography from '@setproduct-ui/core/Typography';
import React, { ComponentProps } from 'react';

export const H6 = ({ children, ...rest }: ComponentProps<typeof Typography>) => (
  <Typography type="h6" tagName="h6" color="default" colorStep={90} {...rest}>
    {children}
  </Typography>
);
